module.exports = __webpack_public_path__ + "img/Italy.7414439e.png";